// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"PasswordSubmitted_iconWrapper__HM0u_"};